<template>
  <div>
    <OrganizationPolicyDetail :goBackDisabled="true" v-if="policy" :id="policy._id"></OrganizationPolicyDetail>
  </div>
</template>

<script>
import PolicyComplianceStatusDescription from "../component/policy-compliance-status-description";
import PolicyComplianceStatusSelect from "../component/policy-compliance-status-select";
import PolicyPeriodicalSelect from "../component/policy-periodical-select";
import OrganizationPolicyDetail from "../organization-policy-detail.vue";
import PolicyCategoryBadge from "./policy-category-badge";
import PolicyStatusSelect from "./policy-status-select";
import RiskItem from "./risk-item";

export default {
  props: ["product"],
  components: {
    PolicyStatusSelect,
    OrganizationPolicyDetail,
    PolicyPeriodicalSelect,
    PolicyComplianceStatusSelect,
    PolicyComplianceStatusDescription,
    RiskItem,
    PolicyCategoryBadge,
  },

  data() {
    return { selectedRisk: undefined, complianceStatusesVisible: {}, form: undefined };
  },
  computed: {
    policy() {
      return this.$store.getters["organizationPolicy/policy"];
    },
    isLoading() {
      return this.$store.getters["organizationPolicy/isLoading"];
    },
    hasUnworkedPermission() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_DDO_PRODUCT_ADMIN",
          "ORGANIZATION_BGYS_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    policy: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form = {
            ...this.prepareFormForEdit(v),
          };
        }
      },
    },
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    goBack() {
      const path = `/${this.currentProduct && this.currentProduct != "PLATFORM" ? this.currentProduct.toLowerCase() : "organization"}/policy`;
      this.$router.push(path);
    },
    fetchDetail() {
      if (!this.policy) {
        return;
      }
      this.$store.dispatch("organizationPolicy/fetchDetail", this.policy._id);
    },
    icon(product) {
      if (product == "KVKK") {
        return "/icons/kvkk-active.svg";
      }
      if (product == "GDPR") {
        return "/icons/gdpr-active.svg";
      }
      if (product == "DDO") {
        return "/icons/ddo-active.svg";
      }
      if (product == "BGYS") {
        return "/icons/bgys-active.svg";
      }
    },
    periodEdited(event, policy) {
      if (event.isPeriodical != policy.isPeriodical) {
      } else {
        this.fetchDetail();
      }
    },
    createTask(compliance) {
      this.$store.commit("task/showTaskCreateModal", true);
    },
    async taskSaved() {
      this.$refs["taskFilter" + this.selectedComplianceStatus.definitionId]?.map((i) => i.reset());

      //burada tedbirin önceki statusu ile sonraki statusu değişti ise paginate çağırılsın şeklinde yapılabilir.
      this.fetchDetail();
    },
    showComplianceActions(compliance) {
      return compliance.acceptance != compliance.targetAcceptance;
    },
    async save(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      await this.$store.dispatch("organizationPolicy/changePolicyStatus", id);
      this.fetchDetail();
    },
    redirectToRisk(id) {
      if (!id) {
        return;
      }
      this.$router.push(`/${this.currentProduct.toLowerCase()}/risk-detail/${id}`);
    },

    selectElement(complianceStatus, index) {
      const id = complianceStatus._id;
      this.policy.complianceStatuses.forEach((status) => {
        if (status._id !== id) {
          this.$set(this.complianceStatusesVisible, status._id, false);
        }
      });

      this.$set(this.complianceStatusesVisible, id, !this.complianceStatusesVisible[id]);

      this.selectedComplianceStatus = complianceStatus;
      this.selectedPolicy = this.policy;
    },
    openTaskDetailModal(task) {
      this.$store.commit("task/showTaskDetailModal", true);
      return this.$store.dispatch("task/fetchDetail", task._id);
    },

    create() {
      this.$store.commit("organizationPolicy/isCreating", true);
    },
    saveDescription() {
      try {
        this.$store.dispatch("organizationPolicy/updateComplianceStatusDescription", true);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async deleteById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationPolicy/delete`, id);

        this.$toast.success(this.$t("common.successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async revertDeletedById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationPolicy/revertDeleted`, id);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    // openPolicyDetailModal(policy) {
    //   this.$store.commit("organizationPolicy/policyId", policy._id);
    // },

    async unlinkRisk(risk, policy) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        // if (this.isEditing) {
        await this.$store.dispatch("organizationPolicy/removePolicyRiskRelation", {
          policyId: policy._id,
          riskId: risk._id,
        });
        // }

        policy.risks = policy.risks.filter((i) => i._id != risk._id);
        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithRisk(policy) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        //   if (this.isEditing) {
        const response = await this.$store.dispatch("organizationPolicy/addPolicyRiskRelation", {
          policyId: policy._id,
          riskId: this.selectedRisk._id,
        });

        policy.risks.push(response.data.risk);
        this.selectedRisk = undefined;
        policy.showRiskLinkPanel = false;

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));

        //this.$store.dispatch("organizationPolicy/fetchDetail", this.selectedPolicy._id);
        // } else {
        //   if (!this.form.risks.find((i) => i._id == this.selectedRisk._id)) {
        //     this.form.risks.push({ _id: this.selectedRisk._id, name: this.selectedRisk.name });
        //   }
        // }
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onRiskSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationRisk/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onRiskSelect(risk) {
      this.selectedRisk = risk;
      this.$forceUpdate();
    },

    async unlinkTask(task, complianceStatus) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("task/removeTaskPolicyRelation", {
          policyId: this.selectedPolicy._id,
          taskId: task._id,
          complianceStatusDefinitionId: complianceStatus.definitionId,
        });

        complianceStatus.tasks = complianceStatus.tasks.filter((i) => i._id != task._id);

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithTask(complianceStatus) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const response = await this.$store.dispatch("task/addTaskPolicyRelation", {
          policyId: this.selectedPolicy._id,
          taskId: complianceStatus.selectedTask._id,
          complianceStatusDefinitionId: complianceStatus.definitionId,
        });
        //await this.$store.dispatch("organizationPolicy/fetchDetail", this.selectedPolicy._id);
        //
        complianceStatus.tasks.push(response.data.task);
        complianceStatus.selectedTask = undefined;
        complianceStatus.showTaskLinkPanel = false;

        this.$forceUpdate();

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onTaskSearch(value, callback) {
      const response = await this.$store.dispatch(`task/fetchOrganizationTasks`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onTaskSelect(task, complianceStatus) {
      complianceStatus.selectedTask = task;
      this.$forceUpdate();
    },

    async onComplienceTargetStatusUpdated(value, policy, complianceStatus) {
      complianceStatus.targetAcceptance = definition;
      this.fetchDetail();
      this.$forceUpdate();
    },
    async onComplienceStatusUpdated(value, policy, complianceStatus) {
      complianceStatus.acceptance = value.definition;
      this.fetchDetail();
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        if (this.workedFilter == "WAITING_FOR_ASSESSMENT") {
          payload.status = "WAITING_FOR_ASSESSMENT";
        } else if (this.workedFilter == "IN_PROGRESS") {
          payload.status = "IN_PROGRESS";
        } else if (this.workedFilter == "WAITING_FOR_PERIOD") {
          payload.status = "WAITING_FOR_PERIOD";
        } else if (this.workedFilter == "COMPLETED") {
          payload.status = "COMPLETED";
        } else if (this.workedFilter == "NOT_APPLICABLE") {
          payload.status = "NOT_APPLICABLE";
        }

        const { data: file } = await this.$store.dispatch(`organizationPolicy/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../organization-policy.scss";
</style>
